(() => {
  const initialize = () => {
    document.querySelectorAll('[data-op-menu]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      const nav = document.getElementById(button.getAttribute('aria-controls'));
      if (!nav) return;
      const close = () => { nav.dataset.open = 'false'; button.setAttribute('aria-expanded', 'false'); button.setAttribute('aria-label', 'Open menu'); };
      button.addEventListener('click', () => {
        const open = button.getAttribute('aria-expanded') !== 'true';
        nav.dataset.open = String(open);
        button.setAttribute('aria-expanded', String(open));
        button.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      });
      nav.addEventListener('click', event => { if (event.target.closest('a')) close(); });
      document.addEventListener('keydown', event => { if (event.key === 'Escape' && nav.dataset.open === 'true') { close(); button.focus(); } });
      document.addEventListener('click', event => { if (!nav.contains(event.target) && !button.contains(event.target)) close(); });
      matchMedia('(min-width: 761px)').addEventListener('change', close);
    });
    document.querySelectorAll('[data-op-nav] a').forEach(link => {
      const url = new URL(link.href, location.origin);
      const path = location.pathname.replace(/\/$/, '') || '/';
      const target = url.pathname.replace(/\/$/, '') || '/';
      if (url.origin === location.origin && (path === target || (target.endsWith('/shop') && (/\/products\/|\/collections\//.test(path) || path.endsWith('/shopping'))))) link.setAttribute('aria-current', 'page');
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
